import{m as t}from"./chunk-HBP5N4FR.js";t();var a=`.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table .dapp-core-component__transactionsTableStyles__trim-hash {
  max-width: 8rem;
}
.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table th:last-child,
.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table td:last-child {
  padding-right: 1rem !important;
}
.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table .dapp-core-component__transactionsTableStyles__transaction-value {
  width: 12rem;
}
.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table .dapp-core-component__transactionsTableStyles__transaction-function {
  width: 10.5rem;
}
.dapp-core-component__transactionsTableStyles__transactions-table .dapp-core-component__transactionsTableStyles__table .dapp-core-component__transactionsTableStyles__transaction-function .dapp-core-component__transactionsTableStyles__transaction-function-badge {
  max-width: 9.5rem;
  line-height: 1.2;
}
.dapp-core-component__transactionsTableStyles__transactions-table table {
  text-align: left;
  position: relative;
  border-collapse: collapse;
}
.dapp-core-component__transactionsTableStyles__transactions-table thead {
  background: white;
  position: sticky;
  top: 0; /* required for the stickiness */
  z-index: 99999;
}

.dapp-core-component__transactionsTableStyles__direction-badge {
  color: inherit;
}

.dapp-core-component__transactionsTableStyles__table-wrapper {
  overflow-x: auto;
}
.dapp-core-component__transactionsTableStyles__table-wrapper .dapp-core-component__transactionsTableStyles__table {
  margin: 0;
  white-space: nowrap;
  max-height: 500px;
  overflow: scroll;
}
.dapp-core-component__transactionsTableStyles__table-wrapper .dapp-core-component__transactionsTableStyles__table th {
  border: 0;
}
.dapp-core-component__transactionsTableStyles__table-wrapper .dapp-core-component__transactionsTableStyles__table td {
  vertical-align: middle;
  padding-left: 5px;
  padding-right: 5px;
}

.dapp-core-component__transactionsTableStyles__table .dapp-core-component__transactionsTableStyles__trim-size-sm .dapp-core-component__transactionsTableStyles__trim {
  max-width: 9rem;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(a));var s={"transactions-table":"dapp-core-component__transactionsTableStyles__transactions-table",transactionsTable:"dapp-core-component__transactionsTableStyles__transactions-table",table:"dapp-core-component__transactionsTableStyles__table","trim-hash":"dapp-core-component__transactionsTableStyles__trim-hash",trimHash:"dapp-core-component__transactionsTableStyles__trim-hash","transaction-value":"dapp-core-component__transactionsTableStyles__transaction-value",transactionValue:"dapp-core-component__transactionsTableStyles__transaction-value","transaction-function":"dapp-core-component__transactionsTableStyles__transaction-function",transactionFunction:"dapp-core-component__transactionsTableStyles__transaction-function","transaction-function-badge":"dapp-core-component__transactionsTableStyles__transaction-function-badge",transactionFunctionBadge:"dapp-core-component__transactionsTableStyles__transaction-function-badge","direction-badge":"dapp-core-component__transactionsTableStyles__direction-badge",directionBadge:"dapp-core-component__transactionsTableStyles__direction-badge","table-wrapper":"dapp-core-component__transactionsTableStyles__table-wrapper",tableWrapper:"dapp-core-component__transactionsTableStyles__table-wrapper","trim-size-sm":"dapp-core-component__transactionsTableStyles__trim-size-sm",trimSizeSm:"dapp-core-component__transactionsTableStyles__trim-size-sm",trim:"dapp-core-component__transactionsTableStyles__trim"};export{a,s as b};
//# sourceMappingURL=chunk-3OKDLBWO.js.map
